import { ETypeChart } from '@web/entities/chart/models/type-chart.enum'
import type { TConfigCharts } from '@web/entities/chart/models/types/chart-config.type'
import { EMeasurementType } from '@web/entities/measurement/model/enums/measurement-type.enum'

export const DEFAULT_CURSOR_OVERLAY_WIDTH = 1

export const mapChartConfig: TConfigCharts = {
  [EMeasurementType.TEMPERATURE]: {
    typeChart: ETypeChart.SCALAR,
    size: 50,
    sortDir: 'DESC'
  },
  [EMeasurementType.COMMON_LEVEL]: {
    typeChart: ETypeChart.SCALAR,
    size: 50,
    sortDir: 'DESC'
  },
  [EMeasurementType.SPECTER]: {
    typeChart: ETypeChart.SPECTRUM,
    size: 5,
    sortDir: 'DESC'
  },
  [EMeasurementType.SIGNAL]: {
    typeChart: ETypeChart.TIMING,
    size: 5,
    sortDir: 'DESC'
  },
  [EMeasurementType.RS]: {
    typeChart: ETypeChart.SCALAR,
    size: 50,
    sortDir: 'DESC'
  },
  [EMeasurementType.RD]: {
    typeChart: ETypeChart.SCALAR,
    size: 50,
    sortDir: 'DESC'
  },
  [EMeasurementType.TSR]: {
    typeChart: ETypeChart.TIMING,
    size: 5,
    sortDir: 'DESC'
  },
  [EMeasurementType.TSRD]: {
    typeChart: ETypeChart.TIMING,
    size: 5,
    sortDir: 'DESC'
  },
  [EMeasurementType.TSTM]: {
    typeChart: ETypeChart.TIMING,
    size: 5,
    sortDir: 'DESC'
  },
  [EMeasurementType.OCTAVE]: {
    typeChart: ETypeChart.OCTAVE,
    size: 5,
    sortDir: 'DESC'
  },
  [EMeasurementType.ENVELOPE_SIGNAL]: {
    typeChart: ETypeChart.TIMING,
    size: 5,
    sortDir: 'DESC'
  },
  [EMeasurementType.ENVELOPE_SPECTER]: {
    typeChart: ETypeChart.SPECTRUM,
    size: 5,
    sortDir: 'DESC'
  }
} as const

export const ColorLine = {
  DeepCarminePink: '#E82F2F',
  MediumGreen: '#3CB556',
  FrenchBlue: '#0076BF',
  CadmiumOrange: '#FF801F',
  WarmPurple: '#853892',
  RedBeech: '#803F01',
  ArtyClickSkyBlue: '#2AC4EF',
  PistachioGreen: '#9FC000',
  BlueHosta: '#6EC0C6'
} as const

export const ColorSpectrum = {
  Amplitude: '#444444',
  BackgroundLine: ColorLine.CadmiumOrange
} as const

export const ColorOctave = {
  Background: 'rgba(173, 171, 171, 0.6)',
  Border: '#000000',
  Grid: '#ddd',
  AnnotationBg: 'gray'
} as const

export const ColorScalar = {
  Background: '#000000',
  LabelFont: 'black',
  LabelBg: 'white'
} as const

export const ColorTimeSignal = {
  Background: 'blue',
  Border: 'gray'
} as const

export const ChartHeight = {
  Default: 400,
  Light: 200
} as const

export const ChartResultsLimits = {
  Scalar: 5000,
  NonScalar: 100,
  MaxSave: 50
} as const

export const ChartWorkMode = {
  all: 'all',
  workers: 'workers'
} as const

export type TChartWorkModes = (typeof ChartWorkMode)[keyof typeof ChartWorkMode]
